export default __webpack_public_path__ + "static/media/sidebar-home.05f095e9.svg";